import { Component, OnInit, Inject } from "@angular/core";
import { InvoiceService } from "core/invoices/invoices.service";
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";

export interface DialogData {
	invoice: any;
}

@Component({
	selector: "kt-invoice-detail-edit",
	templateUrl: "./invoice-detail-edit.component.html",
	styleUrls: ["./invoice-detail-edit.component.scss"],
})
export class InvoiceDetailEditDialog implements OnInit {
	working: boolean = true;
	error: null;
	invoice: any;
	constructor(
		private invoiceService: InvoiceService,
		public dialogRef: MatDialogRef<InvoiceDetailEditDialog>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {
		this.invoice = data.invoice;
	}
	ngOnInit() {
		this.working = false;
	}
	save(
		ourReference: string,
		yourReference: string,
		remarks: string
	) {
		try {
			let payload = {};
			if (ourReference != this.invoice.ourReference) {
				payload["ourReference"] = ourReference;
			}
			if (yourReference != this.invoice.yourReference) {
				payload["yourReference"] = yourReference;
			}
			if (remarks != this.invoice.remarks) {
				payload["remarks"] = remarks;
			}
			this.invoiceService
				.setValues(this.invoice.id, payload)
				.then(() => {
					this.dialogRef.close();
				})
				.catch((error: any) => {
					console.log(error);
					this.error = error.error;
				});
		} catch (error) {
			console.log(error);
			this.error = error.message;
		}
	}
}
